module.exports = __webpack_public_path__ + "static/media/pla_green_gaint_straw2.60c4fc79.png";